<template>
  <a-card type="inner" size="small">
    <a-skeleton :loading="processing" active>
      <a-tabs defaultActiveKey="setting-0" tabPosition="left">
        <a-tab-pane tab="Profile" key="setting-0">
          <a-card title="Edit Profile">
            <a-form :form="form" @submit="handleSubmit">
              <a-form-item :label-col="{span: 4}" :wrapper-col="{ span: 6 }" label="Name">
                <a-input placeholder="Name"
                         v-decorator="['name', { initialValue: client.name, rules: [ { required: true } ] } ]">
                </a-input>
              </a-form-item>
              <a-form-item :label-col="{span: 4}" :wrapper-col="{ span: 6 }" label="Username">
                <a-input placeholder="Username"
                         v-decorator="['username', { initialValue: client.username, rules: [ { required: true } ] } ]">
                  <a-icon slot="prefix" type="user" style="color: rgba(0,0,0,0.25)"/>
                </a-input>
              </a-form-item>
              <a-form-item :label-col="{span: 4}" :wrapper-col="{ span: 6 }" label="Phone Number">
                <a-input placeholder="Phone Number"
                         v-decorator="['phone_number', { initialValue: client.phone_number, rules: [ { required: false } ] } ]">
                  <a-icon slot="prefix" type="contacts" style="color: rgba(0,0,0,0.25)"/>
                </a-input>
              </a-form-item>
              <a-form-item :label-col="{span: 4}" :wrapper-col="{ span: 6 }" label="Telegram ID">
                <a-input placeholder="Telegram ID"
                         v-decorator="['telegram_id', { initialValue: client.telegram_id, rules: [ { required: false } ] } ]">
                  <a-icon slot="prefix" type="code" style="color: rgba(0,0,0,0.25)"/>
                </a-input>
              </a-form-item>
              <a-form-item :label-col="{span: 4}" :wrapper-col="{ span: 10 }" label="Email">
                <a-input placeholder="Email"
                         v-decorator="['email', { initialValue: client.email, rules: [ { required: true } ] } ]">
                  <a-icon slot="prefix" type="mail" style="color: rgba(0,0,0,0.25)"/>
                </a-input>
              </a-form-item>
              <a-form-item :wrapper-col="{ span: 12, offset: 4}">
                <a-button type="primary" html-type="submit" :loading="processing" :disabled="processing">Submit
                </a-button>
              </a-form-item>
              <a-form-item>
                <a-input type="hidden"
                         v-decorator="['client_hash', { initialValue: client.hash, rules: [ { required: true }] }]"></a-input>
              </a-form-item>
            </a-form>
          </a-card>
        </a-tab-pane>
        <a-tab-pane tab="Security" key="setting-1">
          <a-card title="Edit Password">
            <a-form :form="form" @submit="handleSubmit">
              <a-form-item :label-col="{span: 6}" :wrapper-col="{ span: 6 }" label="Old Password">
                <a-input type="password" v-decorator="['old_password', { rules: [ { required: true } ] } ]">
                </a-input>
              </a-form-item>
              <a-form-item :label-col="{span: 6}" :wrapper-col="{ span: 6 }" label="New Password">
                <a-input type="password" v-decorator="['password', { rules: [ { required: true } ] } ]">
                </a-input>
              </a-form-item>
              <a-form-item :label-col="{span: 6}" :wrapper-col="{ span: 6 }" label="Password Confirmation">
                <a-input type="password" v-decorator="['password_confirmation', { rules: [ { required: true } ] } ]">
                </a-input>
              </a-form-item>
              <a-form-item :wrapper-col="{ span: 12, offset: 4}">
                <a-button type="primary" html-type="submit" :loading="processing" :disabled="processing">Submit
                </a-button>
              </a-form-item>
            </a-form>
          </a-card>
        </a-tab-pane>
        <!-- <a-tab-pane tab="API Token" key="setting-3">
          <a-card title="API Access">
            <a-row :gutter="[8, 8]">
              <a-col :span="6">
                <span class="float-right"><strong>API Token</strong> : </span>
              </a-col>
              <a-col :span="12">
                <span class="copyable">
                  <a-button size="small" type="link" @click="copy(client.api_token)" icon="copy"></a-button> <code>{{ client.api_token }}</code>
                </span>
              </a-col>
            </a-row>

            <a-row :gutter="[32, 32]">
              <a-col :span="8">
                <div class="float-right">
                  <a-popconfirm
                    title="Sure to revoke API Token?"
                    @confirm="revokeApiToken">
                    <a-button type="danger">Revoke API Token</a-button>
                  </a-popconfirm>
                </div>
              </a-col>
            </a-row>
          </a-card>
        </a-tab-pane> -->
      </a-tabs>
    </a-skeleton>
  </a-card>
</template>

<script>
export default {
  props: {
    path: {
      type: String,
      required: true
    },
    client: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      processing: false,
    }
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, formData) => {
        if (!err) {
          this.processing = true
          this.$http.put(this.routeUri('report.setting.update', {client_hash: this.client.hash}), formData)
            .then((response) => this.handleSuccessResponse(response.data))
            .catch((error) => this.handleErrorResponse(error.response.data.data))
            .finally(() => this.processing = false)
        }
      })
    },
    revokeApiToken() {
      this.processing = true
      this.$http.patch(this.routeUri('report.setting.api.revoke', {client_hash: this.client.hash}), {})
        .then((response) => this.handleSuccessResponse(response.data))
        .catch((error) => this.handleErrorResponse(error.response.data.data))
        .finally(() => this.processing = false)
    },
    handleSuccessResponse(data) {
      this.$notification.success({
        message: "Saved!",
        description: "Data has been successfully saved!."
      });
      window.location.reload();

      setTimeout(() => window.location.href = data.redirect, 3000)
    },
    handleErrorResponse(data) {
      this.form.setFields(_.mapValues(data, function (item, key) {
        return {
          errors: item.map(function (val) {
            return {
              field: key,
              message: val
            }
          })
        }
      }))
      this.form.setFields({password: {value: null}})

      this.$notification.error({
        message: "Failed to validate data",
        description: "We are unable to validate your request."
      })
    }
  }
}
</script>

<style scoped>

</style>
